import React, { useEffect } from 'react';
import { TextFieldOptionsType } from '@aws-amplify/ui-react-native/dist/Authenticator/hooks';
import { Input } from '../../v2BaseComponents/Inputs';
import { TextInputProps } from 'react-native';
import IconButton from '../../v2BaseComponents/IconButton';

type AmplifyAuthenticationFieldOwnProps = {
    errorMessage?: string;
    autoComplete: TextInputProps['autoComplete'];
    staticValue?: string;
};

type AmplifyAuthenticationFieldProps = AmplifyAuthenticationFieldOwnProps & TextFieldOptionsType;

const DefaultAmplifyAuthenticationField: React.FC<AmplifyAuthenticationFieldProps> = ({
    label,
    onChangeText,
    value,
    errorMessage,
    autoComplete,
    onBlur,
    staticValue,
}) => {
    useEffect(() => {
        if (!value && staticValue) {
            setTimeout(() => {
                onChangeText?.(staticValue);
            }, 0);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Input
            onChange={(e) => {
                onChangeText?.(e.nativeEvent.text);
            }}
            title={label || ''}
            value={staticValue || value || ''}
            error={errorMessage}
            autoComplete={autoComplete}
            onBlur={onBlur as any}
            forceFullWidth
            autoCapitalize="none"
            isDisabled={!!staticValue}
        />
    );
};

const SecureAmplifyAuthenticationField: React.FC<AmplifyAuthenticationFieldProps> = ({
    label,
    onChangeText,
    value,
    errorMessage,
    autoComplete,
    onBlur,
}) => {
    const [secureTextEntry, setSecureTextEntry] = React.useState(true);

    return (
        <Input
            onChange={(e) => {
                onChangeText?.(e.nativeEvent.text);
            }}
            title={label || ''}
            value={value || ''}
            error={errorMessage}
            secureTextEntry={secureTextEntry}
            autoComplete={autoComplete}
            onBlur={onBlur as any}
            forceFullWidth
            autoCapitalize="none"
            RightAdornment={
                <IconButton
                    isDisabled={!value}
                    icon={secureTextEntry ? 'EyeOff' : 'Eye'}
                    onPress={() => setSecureTextEntry((prev) => !prev)}
                    variant="minimal"
                    style={{
                        backgroundColor: 'transparent',
                    }}
                />
            }
        />
    );
};

const AmplifyAuthenticationField: React.FC<AmplifyAuthenticationFieldProps & { secureTextEntry: boolean }> = ({
    secureTextEntry,
    ...rest
}) => {
    if (secureTextEntry) return <SecureAmplifyAuthenticationField {...rest} />;
    return <DefaultAmplifyAuthenticationField {...rest} />;
};

export default React.memo(AmplifyAuthenticationField);
